module.exports = __webpack_public_path__ + "media/customizations/sundancenorthlife/logo-new-8adbbf175e6bd719433c74184de49225.png";